import script from "./ParentProductGroupList.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentProductGroupList.vue?vue&type=script&setup=true&lang=js"

import "./ParentProductGroupList.vue?vue&type=style&index=0&id=5eb60333&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb60333"]])

export default __exports__